import { SiteLogo } from '@/components/layout/SiteLogo'
import { useWebsiteContact, useWebsiteServices } from '@/services/httpServices/queries/useWebsite'

function SocialIcon() {
  return (
    <ul className="social-icon">
      <li>
        <a href="#" aria-label="instagram">
          <i className="fa-brands fa-instagram"></i>
        </a>
      </li>
      <li>
        <a href="#" aria-label="facebook">
          <i className="fa-brands fa-facebook-f"></i>
        </a>
      </li>
      <li>
        <a href="#" aria-label="twitter">
          <i className="fa-brands fa-x-twitter"></i>
        </a>
      </li>
      <li>
        <a href="#" aria-label="pinterest">
          <i className="fa-brands fa-pinterest-p"></i>
        </a>
      </li>
    </ul>
  )
}

/** footer-1 — used by every inner page. Exact markup from about.html. */
// NOTE: Service list is loaded dynamically (see useWebsiteServices). Keep in sync with FooterThree.
export function FooterOne() {
  const { services } = useWebsiteServices()
  const { contact } = useWebsiteContact()
  const phoneHref = `tel:${contact.phone.replace(/[^\d+]/g, '')}`

  return (
    <footer className="footer footer-1" data-img-src="/assets/images/footer/footer-1-1.png">
      {/* footer top start */}
      <div className="footer-top">
        <div className="container">
          <div className="footer-top-wrap">
            <div className="row align-items-center">
              <div className="col-lg-4 col-md-12">
                <div className="footer-logo wow fadeInUp" data-wow-delay=".2s">
                  <a href="/">
                    <figure>
                      <SiteLogo textColor="#ffffff" iconColor="#ffffff" taglineGap={2} />
                    </figure>
                  </a>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="footer-contact-info wow fadeInUp" data-wow-delay=".3s">
                  <div className="footer-contact-icon">
                    <i className="fa-solid fa-phone-volume"></i>
                  </div>
                  <div className="footer-contact-content">
                    <span>Have Any Question?</span>
                    <a href={phoneHref}>{contact.phone}</a>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6">
                <div className="footer-contact-info wow fadeInUp" data-wow-delay=".4s">
                  <div className="footer-contact-icon">
                    <i className="fa-solid fa-envelope"></i>
                  </div>
                  <div className="footer-contact-content">
                    <span>Send Email</span>
                    <a href={`mailto:${contact.email}`}>{contact.email}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* footer top end */}

      {/* footer bottom start */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-widget-wrap">
            <div className="row justify-content-between">
              <div className="col-xl-4 col-lg-12">
                <div className="footer-widget footer-widget-about wow fadeInUp" data-wow-delay=".2s">
                  <p>
                    Fast Aid Hospital, Chauddagram is a 24/7 medical care and diagnostic centre committed to
                    quality, affordable healthcare for the people of Chittagong. Our experienced doctors and modern
                    facilities are here for your family at every step.
                  </p>
                  <div className="footer-social-icon">
                    <SocialIcon />
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-sm-6">
                <div className="footer-widget footer-widget-quick-links wow fadeInUp" data-wow-delay=".3s">
                  <h3 className="footer-widget-title">Quick Links</h3>
                  <div className="widget-link">
                    <ul className="link">
                      <li>
                        <a href="/about">
                          <i className="fa-solid fa-chevron-right"></i> About Us
                        </a>
                      </li>
                      <li>
                        <a href="/testimonials">
                          <i className="fa-solid fa-chevron-right"></i> Testimonials
                        </a>
                      </li>
                      <li>
                        <a href="/doctors">
                          <i className="fa-solid fa-chevron-right"></i> Doctors
                        </a>
                      </li>
                      <li>
                        <a href="/services">
                          <i className="fa-solid fa-chevron-right"></i> Services
                        </a>
                      </li>
                      <li>
                        <a href="/contact">
                          <i className="fa-solid fa-chevron-right"></i> Contact
                        </a>
                      </li>
                      <li>
                        <a href="/faq">
                          <i className="fa-solid fa-chevron-right"></i> FAQ
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-sm-6">
                <div className="footer-widget footer-widget-services wow fadeInUp" data-wow-delay=".4s">
                  <h3 className="footer-widget-title">Our Services</h3>
                  <div className="widget-link">
                    <ul className="link">
                      {services.map((service) => (
                        <li key={service.slug}>
                          <a href={`/services/${service.slug}`}>
                            <i className="fa-solid fa-chevron-right"></i> {service.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-xl-3 col-lg-4">
                <div className="footer-widget footer-widget-opening-hours wow fadeInUp" data-wow-delay=".5s">
                  <h3 className="footer-widget-title">Opening Hours</h3>
                  <div className="widget-opening-hours">
                    <ul className="opening-list">
                      <li>
                        <p>
                          Saturday - Thursday: <span className="time">8:00am - 8:00pm</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          Friday: <span className="time">3:00pm - 8:00pm</span>
                        </p>
                      </li>
                      <li>
                        <p>
                          Emergency: <span className="time">24 Hours / 7 Days</span>
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* footer bottom end */}

      {/* footer copyright start */}
      <div className="footer-copyright">
        <div className="container">
          <div className="footer-copyright-wrap">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="copyright-text wow fadeInUp" data-wow-delay=".2s">
                  <p className="m-0">&#169; Copyright 2026 Fast Aid Hospital. All Rights Reserved</p>
                </div>
              </div>
              <div className="col-lg-6 text-lg-end">
                <ul className="footer-bottom-nav wow fadeInUp" data-wow-delay=".3s">
                  <li>
                    <a className="line-effect" href="/terms-and-conditions">
                      Terms and Conditions
                    </a>
                  </li>
                  <li>
                    <a className="line-effect" href="/privacy-policy">
                      Privacy Policy
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* footer copyright end */}
    </footer>
  )
}

/** footer-3 — used by the Home Three landing page. Exact markup from index-3.html. */
export function FooterThree() {
  const { services } = useWebsiteServices()
  const { contact } = useWebsiteContact()
  const phoneHref = `tel:${contact.phone.replace(/[^\d+]/g, '')}`

  return (
    <footer className="footer footer-3" data-img-src="/assets/images/footer/footer-3-1.png">
      {/* footer top start */}
      <div className="footer-top">
        <div className="container">
          <div className="footer-top-wrap">
            <div className="row align-items-center">
              <div className="col-lg-6 col-md-12">
                <div className="footer-social-icon wow fadeInLeft" data-wow-delay=".2s">
                  <SocialIcon />
                </div>
              </div>
              <div className="col-lg-6 col-md-12">
                <div className="widget-subscribe wow fadeInRight" data-wow-delay=".3s">
                  <h4 className="footer-widget-title">Newsletter</h4>
                  <form action="#" onSubmit={(e) => e.preventDefault()}>
                    <div className="form-group">
                      <div className="form-floating field-inner">
                        <input
                          type="text"
                          id="emailid"
                          name="emailid"
                          className="form-control"
                          placeholder="Your Email"
                          autoComplete="off"
                          required
                        />
                        <label htmlFor="emailid">Your Email</label>
                      </div>
                    </div>
                    <button type="submit" className="theme-button style-1" data-text="Send">
                      <span data-text="Send">Send</span>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* footer top end */}

      {/* footer bottom start */}
      <div className="footer-bottom">
        <div className="container">
          <div className="footer-widget-wrap">
            <div className="row">
              <div className="col-lg-3 col-sm-6">
                <div className="footer-widget footer-widget-about wow fadeInUp" data-wow-delay=".2s">
                  <div className="footer-logo mb-30">
                    <a href="/">
                      <figure>
                        <SiteLogo textColor="#ffffff" iconColor="#ffffff" taglineGap={2} />
                      </figure>
                    </a>
                  </div>
                  <p>
                    Fast Aid Hospital, Chauddagram is a 24/7 medical care and diagnostic centre committed to
                    quality, affordable healthcare for the people of Chittagong. Our experienced doctors and modern
                    facilities are here for your family at every step.
                  </p>
                  <div className="button-wapper">
                    <a href="/appointment" className="theme-button style-3" aria-label="Book Appointment">
                      <span data-text="Book Appointment">Book Appointment</span>
                      <i className="fa-solid fa-arrow-right"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="footer-widget footer-widget-quick-links wow fadeInUp" data-wow-delay=".3s">
                  <h4 className="footer-widget-title">Quick Links</h4>
                  <div className="widget-link">
                    <ul className="link">
                      <li>
                        <a href="/about">
                          <i className="fa-solid fa-chevron-right"></i> About Us
                        </a>
                      </li>
                      <li>
                        <a href="/testimonials">
                          <i className="fa-solid fa-chevron-right"></i> Testimonials
                        </a>
                      </li>
                      <li>
                        <a href="/doctors">
                          <i className="fa-solid fa-chevron-right"></i> Doctors
                        </a>
                      </li>
                      <li>
                        <a href="/services">
                          <i className="fa-solid fa-chevron-right"></i> Services
                        </a>
                      </li>
                      <li>
                        <a href="/contact">
                          <i className="fa-solid fa-chevron-right"></i> Contact
                        </a>
                      </li>
                      <li>
                        <a href="/faq">
                          <i className="fa-solid fa-chevron-right"></i> FAQ
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="footer-widget footer-widget-services wow fadeInUp" data-wow-delay=".4s">
                  <h4 className="footer-widget-title">Our Services</h4>
                  <div className="widget-link">
                    <ul className="link">
                      {services.map((service) => (
                        <li key={service.slug}>
                          <a href={`/services/${service.slug}`}>
                            <i className="fa-solid fa-chevron-right"></i> {service.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-sm-6">
                <div className="footer-widget footer-widget-contact wow fadeInUp" data-wow-delay=".5s">
                  <h4 className="footer-widget-title">Get In Touch</h4>
                  <div className="widget-contact">
                    <ul className="contact-info">
                      <li>
                        <p>
                          <i className="fa-solid fa-location-dot"></i>
                          {contact.address}
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="fa-solid fa-envelope"></i>
                          <a href={`mailto:${contact.email}`}>{contact.email}</a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="fa-solid fa-phone-volume"></i>
                          <a href={phoneHref}>{contact.phone}</a>
                        </p>
                      </li>
                      <li>
                        <p>
                          <i className="fa-solid fa-clock"></i>
                          {contact.workingHours}
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* footer bottom end */}

      {/* footer copyright start */}
      <div className="footer-copyright">
        <div className="container">
          <div className="footer-copyright-wrap">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright-text text-center wow fadeInUp" data-wow-delay=".2s">
                  <p className="m-0">&#169; Copyright 2026 Fast Aid Hospital. All Rights Reserved</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* footer copyright end */}
    </footer>
  )
}
